import React, { useState, useEffect } from "react";
import PhoneEnabledIcon from "@mui/icons-material/PhoneEnabled";
import CloseIcon from "@mui/icons-material/Close";
import ZoomInIcon from "@mui/icons-material/ZoomIn";

import MenuImage from "../../images/kg_menu_donburi_Oct25.jpeg";
import MenuImageHalfSize from "../../images/kg_menu_half-size_Oct25.jpeg";
import DrinksMenu from "../../images/kg-drinks-jan24.JPG";
import RecommendedImageDonburi from "../../images/kg_recommened_donburi.jpg";
import RecommendedImageNoodles from "../../images/kg_reommended_noodles.jpg";
import RecommendedImageSides from "../../images/kg_recommended_side-dish.jpg";

import "../../style/view-menu.css";

function ViewMenu() {
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedLabel, setSelectedLabel] = useState("");

  // Handle opening lightbox
  const openLightbox = (image, label) => {
    setSelectedImage(image);
    setSelectedLabel(label);
    document.body.style.overflow = 'hidden'; // Prevent background scrolling
  };

  // Handle closing lightbox
  const closeLightbox = () => {
    setSelectedImage(null);
    setSelectedLabel("");
    document.body.style.overflow = 'unset'; // Restore scrolling
  };

  // Close on ESC key
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') {
        closeLightbox();
      }
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, []);

  return (
    <div className="view-menu-page">
      {/* Hero Section */}
      <div className="view-menu-hero">
        <div className="view-menu-hero-content">
          <h1 className="view-menu-hero-title">
            Our <span className="view-menu-hero-brand">Menu</span>
          </h1>
          <p className="view-menu-hero-subtitle">メニュー</p>
          <div className="view-menu-hero-updated">Updated October 2025</div>
        </div>
      </div>

      {/* Contact Section */}
      <div className="view-menu-contact">
        <div className="view-menu-contact-content">
          <h2 className="view-menu-contact-title">Need Help? Call Us</h2>
          <p className="view-menu-contact-subtitle">お問い合わせ</p>
          <a href="tel:6493078080" className="view-menu-phone-link">
            <PhoneEnabledIcon />
            <span>09-307-8080</span>
          </a>
        </div>
      </div>

      {/* Menu Images Section */}
      <div className="view-menu-section">
        <div className="view-menu-container">
          <h2 className="view-menu-section-title">Our Menu</h2>
          <div className="view-menu-divider"></div>
          
          <div className="view-menu-grid">
            <div className="view-menu-item" onClick={() => openLightbox(MenuImage, "Donburi Menu")}>
              <div className="view-menu-item-image-wrapper">
                <img src={MenuImage} alt="Donburi Menu" />
                <div className="view-menu-zoom-overlay">
                  <ZoomInIcon />
                  <span>Click to Enlarge</span>
                </div>
              </div>
              <p className="view-menu-item-label">Donburi Menu</p>
            </div>

            <div className="view-menu-item" onClick={() => openLightbox(MenuImageHalfSize, "Half Size Menu")}>
              <div className="view-menu-item-image-wrapper">
                <img src={MenuImageHalfSize} alt="Half Size Menu" />
                <div className="view-menu-zoom-overlay">
                  <ZoomInIcon />
                  <span>Click to Enlarge</span>
                </div>
              </div>
              <p className="view-menu-item-label">Half Size Menu</p>
            </div>

            <div className="view-menu-item" onClick={() => openLightbox(DrinksMenu, "Drinks Menu")}>
              <div className="view-menu-item-image-wrapper">
                <img src={DrinksMenu} alt="Drinks Menu" />
                <div className="view-menu-zoom-overlay">
                  <ZoomInIcon />
                  <span>Click to Enlarge</span>
                </div>
              </div>
              <p className="view-menu-item-label">Drinks Menu</p>
            </div>
          </div>
        </div>
      </div>

      {/* Recommended Section */}
      <div className="view-menu-recommended-section">
        <div className="view-menu-container">
          <h2 className="view-menu-section-title">Chef's Recommendations</h2>
          <p className="view-menu-section-subtitle">Our most popular dishes</p>
          
          <div className="view-menu-grid">
            <div className="view-menu-item" onClick={() => openLightbox(RecommendedImageDonburi, "Recommended Donburi")}>
              <div className="view-menu-item-image-wrapper">
                <img src={RecommendedImageDonburi} alt="Recommended Donburi" />
                <div className="view-menu-zoom-overlay">
                  <ZoomInIcon />
                  <span>Click to Enlarge</span>
                </div>
              </div>
              <p className="view-menu-item-label">Recommended Donburi</p>
            </div>

            <div className="view-menu-item" onClick={() => openLightbox(RecommendedImageNoodles, "Recommended Noodles")}>
              <div className="view-menu-item-image-wrapper">
                <img src={RecommendedImageNoodles} alt="Recommended Noodles" />
                <div className="view-menu-zoom-overlay">
                  <ZoomInIcon />
                  <span>Click to Enlarge</span>
                </div>
              </div>
              <p className="view-menu-item-label">Recommended Noodles</p>
            </div>

            <div className="view-menu-item" onClick={() => openLightbox(RecommendedImageSides, "Recommended Side Dishes")}>
              <div className="view-menu-item-image-wrapper">
                <img src={RecommendedImageSides} alt="Recommended Side Dishes" />
                <div className="view-menu-zoom-overlay">
                  <ZoomInIcon />
                  <span>Click to Enlarge</span>
                </div>
              </div>
              <p className="view-menu-item-label">Recommended Side Dishes</p>
            </div>
          </div>
        </div>
      </div>

      {/* Disclaimer */}
      <div className="view-menu-disclaimer">
        <p>*Prices are subject to change at any moment.</p>
      </div>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div className="view-menu-lightbox" onClick={closeLightbox}>
          <div className="view-menu-lightbox-content" onClick={(e) => e.stopPropagation()}>
            <button className="view-menu-lightbox-close" onClick={closeLightbox}>
              <CloseIcon />
            </button>
            <div className="view-menu-lightbox-image-container">
              <img src={selectedImage} alt={selectedLabel} />
            </div>
            <p className="view-menu-lightbox-label">{selectedLabel}</p>
            <p className="view-menu-lightbox-hint">Click outside or press ESC to close</p>
          </div>
        </div>
      )}
    </div>
  );
}

export default ViewMenu;
